export default "__VITE_ASSET__514d36ae__"